module.exports = __webpack_public_path__ + "static/media/5.98219a26.jpg";